import React from "react";
import { withStyles, Button } from "@material-ui/core";
import Select from "../../../../common/StyledSelect";
import Recommendation from "./Recommendation";
import appConstants from "../../../../../appConstants";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${theme.AppBGColor}`,
    marginTop: 16,
    marginBottom: 8,
  },
  label: {
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.HeaderSelectedText,
    marginTop: 12,
    marginBottom: 10,
  },
  driverNameLabel: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
    marginRight: 10,
  },
  driverNameLabelMargin: {
    marginRight: 16,
  },
  driver: {
    display: "flex",
    marginBottom: 16,
    alignItems: "center",
  },
  driverInfeasibleContainer: {
    alignItems: "center",
  },
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    justifyContent: "space-between",
  },
  noRecommendations: { textAlign: "center" },
  assignBtn: {
    right: "2%",
    width: "25%",
    height: "56%",
    marginLeft: 10,
  },
  flexRow: {
    display: "flex",
    flex: 0.97,
    maxWidth: 306,
  },
  selectRoot: {
    marginTop: 0,
    marginBottom: 0,
  },
  inputField: {
    height: 28,
    padding: 0,
  },
  inputLabel: {
    paddingTop: 0,
    fontSize: theme.headerTextFontSize,
    transform: `translate(14px, 6px) scale(1)`,
  },
});

class ManualDriverAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDriver: null,
      isFeasibleOption: null,
      drivers: [],
    };
  }

  componentDidMount() {
    this.setState({
      drivers: this.getDispatchedDriversForManualPickupAssignment(),
    });
  }

  getDispatchedDriversForManualPickupAssignment = () => {
    const { recommendationData, dispatchedDrivers } = this.props;
    const feasibleDriversExcludingTop = recommendationData
      .filter((r) => r.isFeasibleOption)
      .slice(appConstants.MAX_FEASIBLE_DRIVERS);

    const infeasibleDrivers = recommendationData.filter(
      (r) => !r.isFeasibleOption
    );

    const recommendedDriverIds = recommendationData.map((r) =>
      r.driverId?.toLowerCase()
    );
    const nonRecommendedDispatchedDrivers = dispatchedDrivers.filter(
      (driver) => !recommendedDriverIds.includes(driver.driverId?.toLowerCase())
    );

    return [
      ...feasibleDriversExcludingTop,
      ...infeasibleDrivers,
      ...nonRecommendedDispatchedDrivers,
    ].map((driver) => ({
      label: `${driver.driverName}`,
      value: driver.driverId,
      labelSuffix: `(${driver.driverNumber})`,
      isFeasibleOption: driver?.isFeasibleOption ?? false,
    }));
  };

  handleDriverChange = (option) => {
    const driverId = option ? option.value : null;
    this.setState({
      selectedDriver: driverId,
      isFeasibleOption: option?.isFeasibleOption ?? null,
    });
    if (driverId) {
      this.props.glEventHub.emit("SelectDriverRoutes", [driverId]);
    }
  };

  renderDriverRecommendation() {
    const {
      classes,
      assignPickup,
      pickupId,
      terminalOffset,
      recommendationData,
    } = this.props;
    const { selectedDriver } = this.state;

    if (!selectedDriver) {
      return null;
    }

    const selectedDriverRecommendationData = recommendationData.find(
      (r) => r.driverId?.toLowerCase() === selectedDriver?.toLowerCase()
    );

    if (!selectedDriverRecommendationData) {
      return (
        <div className={classes.noRecommendations}>
          <h3>KPI details not available</h3>
        </div>
      );
    }

    return (
      <Recommendation
        data={selectedDriverRecommendationData}
        onClick={() => assignPickup(selectedDriver, pickupId)}
        terminalOffset={terminalOffset}
      />
    );
  }

  render() {
    const { classes, pickupId, assignPickup, isFeasibleOption } = this.props;
    const { selectedDriver, drivers } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.label}>Assign Manually</div>
        <div
          className={`${classes.driver} ${
            !isFeasibleOption ? classes.driverInfeasibleContainer : ""
          }`}
        >
          <span
            className={`${classes.driverNameLabel} ${
              isFeasibleOption ? classes.driverNameLabelMargin : ""
            }`}
          >
            Driver Name
          </span>
          <div className={classes.dropdownContainer}>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "customer",
                  label: "Select driver",
                  variant: "outlined",
                  helperText: "",
                  InputLabelProps: {
                    classes: {
                      root: classes.inputLabel
                    }
                  }
                }}
                InputPropsClasses={{
                  input: classes.inputField,
                }}
                value={selectedDriver}
                onChange={this.handleDriverChange}
                error={Boolean(this.state.errorInfo)}
                data={drivers}
                rootClass={classes.selectRoot}
              />
            </div>
            {!isFeasibleOption && (
              <Button
                color="primary"
                variant="contained"
                size="small"
                className={classes.assignBtn}
                onClick={() => assignPickup(selectedDriver, pickupId)}
                disabled={!Boolean(selectedDriver)}
              >
                Assign
              </Button>
            )}
          </div>
        </div>
        {isFeasibleOption && this.renderDriverRecommendation()}
      </div>
    );
  }
}

export default withStyles(styles)(ManualDriverAssignment);